export default "__VITE_ASSET__y98mUUU6__"